import Layout from "@/components/layout/Layout";
import SEOHead from "@/components/SEOHead";
import CorporateFinanceHome from "./CorporateFinanceHome";

export default function Index() {
  return (
    <Layout>
      <SEOHead
        title="SYCMA Corporate Finance | Investment Banking & M&A Advisory en Español"
        description="Firma boutique de banca de inversión y asesoría financiera para empresas hispanohablantes en Americas y Europa. M&A, levantamiento de capital, CFO as a Service con estándares internacionales. Más de US$10 billones en transacciones acompañadas."
        path="/"
      />
      <CorporateFinanceHome />
    </Layout>
  );
}
